import { render, staticRenderFns } from "./classContrast.vue?vue&type=template&id=63f9f80a&scoped=true"
import script from "./classContrast.vue?vue&type=script&lang=js"
export * from "./classContrast.vue?vue&type=script&lang=js"
import style0 from "./classContrast.vue?vue&type=style&index=0&id=63f9f80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9f80a",
  null
  
)

export default component.exports